var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExistingUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#0A64C8",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7069_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6667 70C53.6933 70 48.8333 65.14 48.8333 59.1667C48.8333 53.1933 53.6933 48.3333 59.6667 48.3333C65.64 48.3333 70.5 53.1933 70.5 59.1667C70.5 65.14 65.64 70 59.6667 70ZM59.6667 51.6667C55.5317 51.6667 52.1667 55.0317 52.1667 59.1667C52.1667 63.3017 55.5317 66.6667 59.6667 66.6667C63.8017 66.6667 67.1667 63.3017 67.1667 59.1667C67.1667 55.0317 63.8017 51.6667 59.6667 51.6667ZM61.3317 62.2567L64.475 59.2017C65.135 58.56 65.15 57.505 64.51 56.845C63.8683 56.1867 62.8133 56.1683 62.1533 56.8117L59 59.875C58.835 60.0417 58.5633 60.0417 58.3967 59.875L56.9367 58.445C56.2783 57.8017 55.225 57.8133 54.58 58.4717C53.935 59.13 53.9467 60.1833 54.605 60.8283L56.065 62.2583C56.7933 62.9717 57.7483 63.3267 58.7017 63.3267C59.655 63.3267 60.6117 62.9683 61.3333 62.255L61.3317 62.2567ZM45.5 50C39.985 50 35.5 45.515 35.5 40C35.5 34.485 39.985 30 45.5 30C51.015 30 55.5 34.485 55.5 40C55.5 45.515 51.015 50 45.5 50ZM45.5 33.3333C41.8233 33.3333 38.8333 36.3233 38.8333 40C38.8333 43.6767 41.8233 46.6667 45.5 46.6667C49.1767 46.6667 52.1667 43.6767 52.1667 40C52.1667 36.3233 49.1767 33.3333 45.5 33.3333ZM33.8333 68.3333C33.8333 62.46 38.2217 57.4817 44.04 56.7567C44.9533 56.6433 45.6017 55.81 45.4883 54.8967C45.375 53.9833 44.5317 53.345 43.6283 53.45C36.1433 54.3817 30.5 60.7817 30.5 68.3333C30.5 69.255 31.2467 70 32.1667 70C33.0867 70 33.8333 69.255 33.8333 68.3333Z",
    fill: "#0A64C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7069_10638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingUser);
export default __webpack_public_path__ + "static/media/existing-user.0d396d14aabbd28186b302f67e07f93d.svg";
export { ForwardRef as ReactComponent };